import $ from 'jquery'
import _ from 'lodash'
import template from './datasets-filter-equation-form.hbs'
import DatasetsEquationForm from 'scoreboard/datasets/equations/datasets-equation-form'
import filterEquationParser from './filter-equation-parser'
import FilterEquationFormatter from './filter-equation-formatter'
import renderFieldDropdown from '../render-field-dropdown'
import isGeographicOrRollup from '../is-geographic-or-rollup'

var DatasetsFilterEquationForm = DatasetsEquationForm.extend({

	equationParser: filterEquationParser,
	equationFormatter: FilterEquationFormatter,

	className: DatasetsEquationForm.prototype.className + ' dataset-filter-equation',

	events: _.defaults({
		'change [name=fieldId]': 'toggleAddEnabled'
	}, DatasetsEquationForm.prototype.events),

	/** @type {Dataset} */
	model: null,

	/**
	 * Editor for equations for dataset filters
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the Dataset
	 *
	 * @param {Object} options.field the field being filtered on
	 *
	 * @param {Object} [options.visibleLinkedField] the visible linked field
	 * being filter on (if the field is linked in from another dataset)
	 *
	 * @param {String} options.title the title of the dialog
	 *
	 * @param {String} options.dataType the expected dataType for the results of
	 * the equation
	 *
	 * @param {String} [options.equation] an equation to be edited
	 */
	initialize: function(options = {}) {
		DatasetsEquationForm.prototype.initialize.apply(this, arguments)
	},

	render: function() {
		DatasetsEquationForm.prototype.render.apply(this, arguments)
		this.$('.equation-controls .panel-content').append(template())

		this.renderFieldDropdown()

		this.equationEditor.allowFunctionTooltip = false

		return this
	},

	renderFieldDropdown: function() {
		// #54607 fallback to this.model.id for pseudo-fields that aren't
		// specific to a particular dataset
		let datasetId = this.options.field.datasetId ?? this.model.get('rootDatasetId')
		let dataset = this.model.datasetsById[datasetId]
		let fields, allowedVisibleLinkedFieldIds
		if (this.model.get('rootDatasetId') == datasetId) {
			// #18694 for now only allow selection of fields within the same dataset
			// as the field we are filtering on
			fields = _.filter(dataset.get('fields'), field =>
				!isGeographicOrRollup(field.dataType))
		} else {
			allowedVisibleLinkedFieldIds = _.filter(
				this.model.get('visibleLinkedFields'),
				vlf => vlf.path == _.get(this.options.visibleLinkedField, 'path'))
		}

		renderFieldDropdown({
			el: this.$('[name=fieldId]'),
			allowedFieldIds: _.map(fields, 'id'),
			allowedVisibleLinkedFieldIds: _.map(allowedVisibleLinkedFieldIds, 'id'),
			dataset: this.model
		})
	},

	createEquationEditor: function() {
		DatasetsEquationForm.prototype.createEquationEditor.apply(this, arguments)
		this.equationEditor.on('selection', () => this.toggleAddEnabled())
	},

	toggleAddEnabled: function() {
		let fieldId = this.$('[name=fieldId]').val()

		let match = _.get(this.equationEditor._matches, this.equationEditor._matchIndex)
		var enabled = _.get(match, 'fieldId') != fieldId
		this.$('button.done').attr('disabled', !enabled)

		let addEnabled = !!fieldId
		this.$('button.add').attr('disabled', !addEnabled)
	},

	// handles this.equationEditor.on('edit')
	edit: function(match) {
		if (match.fieldId) {
			this.$('[name=fieldId]').val(match.fieldId)
		}
	},

	submit: function() {
		let equation = this.equationEditor.getCleanEquation()
		var url = `api/datasets/${this.model.id}/validate-filter-equation?`
		let data = {
			equation,
			dataType: this.options.dataType,
			fieldId: this.options.field.id,
			visibleLinkedFieldId: _.get(this.options, 'visibleLinkedField.id')
		}
		$.post({
			url: url,
			data: JSON.stringify(data),
			success: () => this.trigger('done', equation),
			error: this.onInvalidEquation.bind(this)
		})
	}

})

export default DatasetsFilterEquationForm

DatasetsFilterEquationForm.__filename__ = 'datasets/filters/datasets-filter-equation-form.js'
